import { UpdateListOwnershipRequest } from '@cbinsights/listservice/listservice';
import { request } from 'client/modules/common/utils/request';

export const updateListOwnership = (
  req: UpdateListOwnershipRequest
): Promise<void> =>
  request({
    url: '/service/listservice/UpdateListOwnership',
    body: { ...req },
  }).then((r) => r.body);
